import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-add-staff-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-staff-modal.component.html',
  styleUrls: ['./add-staff-modal.component.scss']
})
export class AddStaffModalComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  @Output() submitStaff = new EventEmitter<any>();

  @Input() isEdit = false;
  @Input() staffData: any = null;

  staff = {
    name: '',
    email: '',
    phone_number: '',
    address: '',
    state: '',
    city: '',
    pincode: ''
  };

  submitting = false;
  errorMsg = '';
  fieldErrors: { [key: string]: string } = {};

  pinLocationVerified = false;
  pincodeVerifying = false;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    if (this.isEdit && this.staffData) {
      this.staff = {
        name: this.staffData.name || '',
        email: this.staffData.email || '',
        phone_number: this.staffData.phone_number || '',
        address: this.staffData.address || '',
        state: this.staffData.state || '',
        city: this.staffData.city || '',
        pincode: this.staffData.pincode ? String(this.staffData.pincode) : ''
      };
      // If editing and pincode exists, treat location as already verified
      if (this.staff.pincode) {
        this.pinLocationVerified = true;
      }
    }
  }

  onPincodeChange(pincode: string) {
    if (pincode && pincode.toString().trim().length === 6) {
      this.pincodeVerifying = true;
      this.http.get<any>(`${environment.apiBaseUrl}/admin/external/pincode/${pincode.toString().trim()}`).subscribe({
        next: (res) => {
          this.pincodeVerifying = false;
          if (res && res.data && res.data[0] && res.data[0].Status === 'Success' && res.data[0].PostOffice && res.data[0].PostOffice.length > 0) {
            const postOffice = res.data[0].PostOffice[0];
            this.staff.city = postOffice.District || postOffice.Block;
            this.staff.state = postOffice.State;
            this.pinLocationVerified = true;
          } else {
            this.pinLocationVerified = false;
          }
        },
        error: () => {
          this.pincodeVerifying = false;
          this.pinLocationVerified = false;
        }
      });
    } else {
      this.pinLocationVerified = false;
    }
  }

  validate() {
    this.fieldErrors = {};

    if (!this.staff.name || this.staff.name.trim().length === 0) {
      this.fieldErrors['name'] = 'Name is required.';
    }

    if (!this.staff.email) {
      this.fieldErrors['email'] = 'Email is required.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.staff.email)) {
      this.fieldErrors['email'] = 'Invalid email format.';
    }

    if (!this.staff.phone_number) {
      this.fieldErrors['phone_number'] = 'Phone Number is required.';
    } else if (!/^\d{10,}$/.test(String(this.staff.phone_number))) {
      this.fieldErrors['phone_number'] = 'Invalid phone number.';
    }

    if (!this.staff.address || this.staff.address.trim().length === 0) {
      this.fieldErrors['address'] = 'Address is required.';
    }

    if (!this.staff.state || this.staff.state.trim().length === 0) {
      this.fieldErrors['state'] = 'State is required.';
    }

    if (!this.staff.city || this.staff.city.trim().length === 0) {
      this.fieldErrors['city'] = 'City is required.';
    }

    if (!this.staff.pincode) {
      this.fieldErrors['pincode'] = 'Pincode is required.';
    } else if (!/^\d{6}$/.test(String(this.staff.pincode))) {
      this.fieldErrors['pincode'] = 'Invalid pincode (must be 6 digits).';
    }

    return Object.keys(this.fieldErrors).length === 0;
  }

  onSubmit() {
    this.errorMsg = '';
    if (!this.validate()) {
      this.errorMsg = 'Please fix the errors above.';
      return;
    }
    this.submitting = true;

    const userStr = localStorage.getItem('user');
    let userId = '';
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        userId = user.user_id;
      } catch {}
    }

    const payload = this.isEdit
      ? { ...this.staff, updated_by: userId }
      : { ...this.staff, created_by: userId };

    this.submitStaff.emit(payload);
  }

  resetSubmitting() {
    this.submitting = false;
  }

  onClose() {
    this.close.emit();
  }
}
